'use strict';

angular.module('TurneroApp').component('coGrupoUsuariosAlta', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'grupoUsuarioService',
        'utilsService',
        'TurneroAppConstant',
        function (grupoUsuarioService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.grupoAlta = {};
            ctrl.listaUsuariosAlta = [];

            ctrl.errores = {
                Usuarios: false,
                N_Grupo_Usuario: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.grupoAlta = {};
                    ctrl.listaUsuariosAlta = [];

                    ctrl.errores = {
                        Usuarios: false,
                        N_Grupo_Usuario: false,
                    };

                    grupoUsuarioService.getInfo({
                        'id_Grupo_Usuario': ' ',
                        'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                    }).$promise.then(function (data) {
                        ctrl.grupoAlta = data
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }
            };

            ctrl.cambiosEnUsuarios = function () {
                ctrl.grupoAlta.Id_Usuario_Alta = '';

                if (ctrl.listaUsuariosAlta.length > 1) {
                    for (var i = 0; i < ctrl.listaUsuariosAlta.length; i++) {
                        ctrl.grupoAlta.Id_Usuario_Alta = ctrl.grupoAlta.Id_Usuario_Alta.length ? ctrl.grupoAlta.Id_Usuario_Alta + ',' + ctrl.listaUsuariosAlta[i].id.toString() : ctrl.listaUsuariosAlta[i].id.toString();
                        ctrl.errores.Usuarios = false;
                    }
                } else {
                    ctrl.errores.Usuarios = true;
                }
            };


            ctrl.guardarGrupoNuevo = function () {
                ctrl.errores.N_Grupo_Usuario = !(ctrl.grupoAlta.N_Grupo_Usuario);
                ctrl.grupoAlta.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id
                ctrl.errores.Usuarios = !(ctrl.grupoAlta.Id_Usuario_Alta)

                if (ctrl.errores.N_Grupo_Usuario || ctrl.errores.Usuarios) {
                    return;
                }

                if (ctrl.grupoAlta.Id_Usuario_Alta.length > 0) {
                    grupoUsuarioService.save(ctrl.grupoAlta).$promise.then(function (res) {
                        ctrl.ctrlPadre.grillaReload();
                        sweetAlert("Alta Grupo", "El grupo se registró correctamente", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });

                };
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            };
        }
    ],
    template: require('./grupoUsuariosAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/grupos/grupos-usuarios/grupoUsuariosAltaComponent.js